// TODO: detect if menu items are slotted and add class to ul

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-form-label',
  styleUrl: 'form.css',
  shadow: false,
})
export class FormLabel {
  @Prop() labelText: string = '1rem';
  @Prop() labelFor: string = 'inputName';
  @Prop() labelId: string = '';
  @Prop() isRequired: boolean = false;

  render() {
    return (
      <label class="form_label" htmlFor={this.labelFor} id={this.labelId}>
        {this.labelText}
        {this.isRequired ? (
          <span class="required" aria-haspopup="true">
            &nbsp;*
          </span>
        ) : (
          ''
        )}
      </label>
    );
  }
}
